import { Menu } from 'lucide-react';

import { t } from '@ping/helpers';
import {
  isMainSidebarAvailableSelector,
  isMainSidebarDrawerOpenSelector,
  mainSidebarStore,
  useMainSidebarStore,
} from '@ping/stores/mainSidebar.store';
import { ButtonA11Y } from '@ping/uikit';

import style from './style.module.scss';

/**
 * Header button that opens the main sidebar as a drawer on the viewports where the
 * persistent sidebar is hidden. It renders only while a main sidebar is mounted, and is
 * hidden from `md` up, where that sidebar takes over.
 */
export const MainSidebarMobileTrigger = () => {
  const isAvailable = useMainSidebarStore(isMainSidebarAvailableSelector);
  const isDrawerOpen = useMainSidebarStore(isMainSidebarDrawerOpenSelector);

  if (!isAvailable) return null;

  return (
    <ButtonA11Y
      className={style['main-sidebar-mobile-trigger']}
      aria-label={t('Open navigation')}
      aria-expanded={isDrawerOpen}
      aria-haspopup='dialog'
      onPress={mainSidebarStore.openDrawer}
    >
      <Menu size={22} strokeWidth={2} aria-hidden />
    </ButtonA11Y>
  );
};
